import { Infinity, ShieldAlert, Filter, Power, SlidersHorizontal, BarChart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t } = useTranslation();

  const featuresList = [
    {
      icon: <Infinity className="h-6 w-6 text-blue-600" />,
      title: t('landing.features.items.unlimited.title'),
      description: t('landing.features.items.unlimited.description')
    },
    {
      icon: <ShieldAlert className="h-6 w-6 text-blue-600" />,
      title: t('landing.features.items.spam.title'),
      description: t('landing.features.items.spam.description')
    },
    {
      icon: <Filter className="h-6 w-6 text-blue-600" />,
      title: t('landing.features.items.forwarding.title'),
      description: t('landing.features.items.forwarding.description')
    },
    {
      icon: <Power className="h-6 w-6 text-blue-600" />,
      title: t('landing.features.items.deactivation.title'),
      description: t('landing.features.items.deactivation.description')
    },
    {
      icon: <SlidersHorizontal className="h-6 w-6 text-blue-600" />,
      title: t('landing.features.items.filters.title'),
      description: t('landing.features.items.filters.description')
    },
    {
      icon: <BarChart className="h-6 w-6 text-blue-600" />,
      title: t('landing.features.items.analytics.title'),
      description: t('landing.features.items.analytics.description')
    }
  ];

  return (
    <section id="features" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('landing.features.title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('landing.features.subtitle')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuresList.map((feature, index) => (
            <div 
              key={index} 
              className="flex p-6 rounded-xl hover:bg-blue-50 transition-colors"
            >
              <div className="mr-4 bg-blue-100 p-3 rounded-full h-fit">
                {feature.icon}
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-700">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;